import type { BrandColor } from '~kui/types/kui';

import { hashId } from '~kui/utils/hash';

/**
 * The palette consideration areas cycle through — the single source of truth shared by the
 * considerations profile and the post-completion screen so a given area is coloured identically.
 */
export const CONSIDERATION_COLORS = ['lime', 'coral', 'pink', 'purple', 'orange', 'blue', 'yellow'] as const satisfies readonly BrandColor[];

/** The brand colours a consideration area can use; derived from {@link CONSIDERATION_COLORS}. */
export type ConsiderationColor = typeof CONSIDERATION_COLORS[number];

/**
 * Deterministic, context-free colour for a consideration area, keyed off a stable string (its
 * label). A placeholder until a stored per-area colour exists; the same label always maps to the
 * same colour, so an area looks identical wherever it is shown.
 */
export const considerationAreaColor = (label: string): ConsiderationColor =>
  CONSIDERATION_COLORS[hashId(label) % CONSIDERATION_COLORS.length]!;
